import { useGlobalContext } from "../Context/GlobalContext";

export default function PaginationTab() {
  const {
    currentPage,
    totalPages,
    handlePrevious,
    handleNext,
    totalRecords,
    isLoading,
  } = useGlobalContext();
  return (
    <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[14px] xl:pr-0 pb-[0] xl:pl-0 w-[100%]">
      <p className="text-[#a5a1a1] text-[14px]">
        Total Records : {totalRecords}
      </p>
      <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`pt-2 pb-[8px] text-[12px] ${currentPage === 1 ? "opacity-40" : ""}`}
        >
          Previous
        </button>
        <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
          {/* {`Page ${currentPage} of ${totalPages}`} */}
          {currentPage}
        </span>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`pt-2 pb-[8px] text-[12px] ${currentPage === totalPages ? "opacity-40" : ""}`}
        >
          Next
        </button>
      </div>
    </div>
  );
}
